import React from "react";
import ReactModal from "react-modal";
import "./add-organizations-modal.scss";
import { Formik } from "formik";
import { Col, Form } from "react-bootstrap";
import Loader from "../../loader/loader";
import SelectDropDown from "../../shared/drop-down/drop-down";

import Cleave from "cleave.js/react";
import {
    CreateOrganization,
    GetAdminUsers,
    UpdateOrganization,
    getEmsOffices,
} from "../../../api";
import { services } from "../../../constants";
import Select from "react-select";

import * as yup from "yup";
const schema = yup.object({
    name: yup.string().trim().required("* Name is required"),
    whitelabel_slug: yup.string().trim().required("* Slug is required"),
    email: yup.string().required("* Email required"),
    phone: yup.string().required("* Phone required"),
    address: yup.string().required("* Address required"),
    low_risk: yup.string().required("* Low Risk required").nullable(),
    high_risk: yup.string().required("* High Risk required").nullable(),
    rev_share_tiers: yup
        .string()
        .required("* Revenue Share required")
        .nullable(),
});
class AddOrganizationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emsOffices: [],
            isEdit: props.selectedOrganization ? true : false,
            is_submitted: false,
            relationShipManagers: [],
            mainAdminManagers: undefined,
            showUpdateUwUpdate: false,
            formData: {
                main_admin: props.selectedOrganization
                    ? props.selectedOrganization.main_admin
                    : 0,
                name: props.selectedOrganization
                    ? props.selectedOrganization.name
                    : "",
                company_name: props.selectedOrganization
                    ? props.selectedOrganization.company_name
                    : "",
                main_contact: props.selectedOrganization
                    ? props.selectedOrganization.main_contact
                    : "",
                whitelabel_slug: props.selectedOrganization
                    ? props.selectedOrganization.whitelabel_slug
                    : "",
                email: props.selectedOrganization
                    ? props.selectedOrganization.email
                    : "",
                phone: props.selectedOrganization
                    ? props.selectedOrganization.phone
                    : "",
                address: props.selectedOrganization
                    ? props.selectedOrganization.address
                    : "",
                fileToUpload: null,
                high_risk: props.selectedOrganization
                    ? props.selectedOrganization.high_risk
                    : "",
                primary_contact_id: props.selectedOrganization
                    ? props.selectedOrganization.primary_contact_id
                    : "",
                contract_negotiation: props.selectedOrganization
                    ? props.selectedOrganization.contract_negotiation
                    : "",
                uw_id: props.selectedOrganization
                    ? props.selectedOrganization.uw_id
                    : "",
                type: props.selectedOrganization
                    ? props.selectedOrganization.type
                        ? props.selectedOrganization.type
                        : ""
                    : "",
                low_risk: props.selectedOrganization
                    ? props.selectedOrganization.low_risk
                    : "",
                rev_share_tiers: props.selectedOrganization
                    ? props.selectedOrganization.rev_share_tiers
                    : "",
                bank_name: props.selectedOrganization
                    ? props.selectedOrganization.bank_name
                    : "",
                routing_number: props.selectedOrganization
                    ? props.selectedOrganization.routing_number
                    : "",
                account_number: props.selectedOrganization
                    ? props.selectedOrganization.account_number
                    : "",
                smtp_server: props.selectedOrganization
                    ? props.selectedOrganization.smtp_server
                    : "",
                smtp_port: props.selectedOrganization
                    ? props.selectedOrganization.smtp_port
                    : "",
                smtp_username: props.selectedOrganization
                    ? props.selectedOrganization.smtp_username
                    : "",
                smtp_password: props.selectedOrganization
                    ? props.selectedOrganization.smtp_password
                    : "",
                smtp_encryption: props.selectedOrganization
                    ? props.selectedOrganization.smtp_encryption
                    : "",
                smtp_enabled: props.selectedOrganization
                    ? props.selectedOrganization.smtp_enabled
                    : "",
                ems_office_hr: props.selectedOrganization
                    ? props.selectedOrganization.ems_office_hr
                    : "",
                ems_office_lr: props.selectedOrganization
                    ? props.selectedOrganization.ems_office_lr
                    : "",

                allowed_processors: props.selectedOrganization ?
                    props.selectedOrganization.allowed_processors :
                    [],

                contact_preference: props.selectedOrganization
                    ? props.selectedOrganization.contact_preference
                    : "",
                update_existing_lead_uw_id: false,
            },
            src:
                props.selectedOrganization &&
                props.selectedOrganization.whitelabel_slug
                    ? "/img/" +
                      props.selectedOrganization.whitelabel_slug +
                      "/logo-solid.png?" +
                      localStorage.getItem("counter")
                    : "",
            alt: "",
            errors: [],
            allowedProcessorsOptions: [],
            selectedFile: {},
            classDefault: false,
            errorMessage: "",
            smtpSuccessMessage: "",
            smtpErrorMessage: "",
            smtpEncryptionRequired: "",
            smtpServerRequired: "",
            smtpUsernameRequired: "",
            smtpPasswordRequired: "",
            smtpPortRequired: "",
            isSmtpEnabled: props.selectedOrganization
                ? props.selectedOrganization.smtp_enabled
                : false,
            smtp_ports: [
                { label: "465", value: "465" },
                { label: "587", value: "587" },
            ],
            smtp_encryptions: [
                { label: "SSL", value: "SSL" },
                { label: "TLS", value: "TLS" },
            ],
            show_spinner: false,
            httpErrorMessage: "",
            beta_features:
                props.selectedOrganization &&
                props.selectedOrganization.beta_features == 1
                    ? true
                    : false,
            enable_agent_training:
                props.selectedOrganization &&
                props.selectedOrganization.enable_agent_training == 1
                    ? true
                    : false,
            show_create:
                props.selectedOrganization &&
                props.selectedOrganization.show_create == 1
                    ? true
                    : false,
            pricing_restricted:
                props.selectedOrganization &&
                    props.selectedOrganization.pricing_restricted == 1
                    ? true
                    : false,
        };
    }


    componentDidMount() {
        this.getAdminUsersList();
        this.getOrganizationUserList();
        this.getOffices();
        if (services?.length) {
            let allowedProcessorsTemp = [];
            services.forEach(value => {
                allowedProcessorsTemp.push({
                    "value": value,
                    "label": value,
                })
            });
            this.setState({ allowedProcessorsOptions: allowedProcessorsTemp, })
        }

    }
    // emsOffices
    getOffices() {
        let officesTemp = [];
        getEmsOffices().then((res) => {
            if (res?.status) {
                res?.data.map((office, index) => {
                    officesTemp.push({
                        value: office?.value,
                        label: office?.value
                    });
                });
                this.setState({
                    emsOffices: officesTemp,
                })
            }

        }).catch((err) => { });
    }
    handleOnChange(e) {
        this.setState({
            smtpSuccessMessage: "",
            smtpErrorMessage: "",
            smtpEncryptionRequired: "",
            smtpServerRequired: "",
            smtpUsernameRequired: "",
            smtpPasswordRequired: "",
            smtpPortRequired: "",
        });
    }
    getOrganizationUserList() {
        if (
            this.state.isEdit &&
            this.props.organization_user &&
            this.props.organization_user.length > 0
        ) {
            let useroptions = [];
            this.props.organization_user.map((user, index) => {
                useroptions.push({
                    label: user.name,
                    value: user.id,
                });
            });
            this.setState({ mainAdminManagers: useroptions });
        } else {
            this.setState({ mainAdminManagers: [] });
        }
    }

    getAdminUsersList() {
        GetAdminUsers()
            .then((response) => {
                if (response.success) {
                    const users = response.users;
                    let useroptions = [];
                    users.map((user, index) => {
                        useroptions.push({
                            label: user.name,
                            value: user.id,
                        });
                    });
                    this.setState({ relationShipManagers: useroptions });
                } else {
                    alert(response.message);
                }
            })
            .catch((error) => console.log(error));
    }

    // add organization data
    handleAddOrganization = (evt) => {
        this.setState({ show_spinner: true });
        const fromData = this.state.formData;
        let fd = new FormData();
        if (fromData.main_admin && fromData.main_admin !== "") {
            fd.append("main_admin", fromData.main_admin);
        }
        fd.append("name", fromData.name);
        fd.append("company_name", fromData.company_name);
        fd.append("main_contact", fromData.main_contact);

        fd.append("whitelabel_slug", fromData.whitelabel_slug);
        fd.append("email", fromData.email);
        fd.append("phone", fromData.phone);
        fd.append("address", fromData.address);
        fd.append("high_risk", fromData.high_risk);
        fd.append(
            "primary_contact_id",
            fromData.primary_contact_id && fromData.primary_contact_id !== ""
                ? parseInt(fromData.primary_contact_id)
                : null,
        );
        fd.append(
            "contract_negotiation",
            fromData.contract_negotiation &&
                fromData.contract_negotiation !== ""
                ? parseInt(fromData.contract_negotiation)
                : null,
        );
        fd.append(
            "uw_id",
            fromData.uw_id && fromData.uw_id !== ""
                ? parseInt(fromData.uw_id)
                : null,
        );
        fd.append("type", fromData.type);
        fd.append("low_risk", fromData.low_risk);
        fd.append("rev_share_tiers", fromData.rev_share_tiers);
        fd.append("bank_name", fromData.bank_name);
        fd.append("routing_number", fromData.routing_number);
        fd.append("account_number", fromData.account_number);
        fd.append("contact_preference", fromData.contact_preference);
        fd.append("allowed_processors",
            fromData.allowed_processors && fromData.allowed_processors !== "" ?
                JSON.stringify(fromData.allowed_processors)
                : null);
        fd.append("ems_office_hr", fromData.ems_office_hr);
        fd.append("ems_office_lr", fromData.ems_office_lr);

        fd.append(
            "update_existing_lead_uw_id",
            fromData.update_existing_lead_uw_id,
        );
        if (this.state.isSmtpEnabled) {
            let error = false;
            if (fromData.smtp_server == "") {
                this.setState({
                    smtpServerRequired: "* Smtp Server Required!",
                });
                error = true;
            }
            if (fromData.smtp_port == "") {
                this.setState({ smtpPortRequired: "* Smtp Port Required!" });
                error = true;
            }
            if (fromData.smtp_username == "") {
                this.setState({
                    smtpUsernameRequired: "* Smtp UserName Required!",
                });
                error = true;
            }
            if (fromData.smtp_password == "") {
                this.setState({
                    smtpPasswordRequired: "* Smtp Password Required!",
                });
                error = true;
            }
            if (fromData.smtp_encryption == "") {
                this.setState({
                    smtpEncryptionRequired: "* Smtp Encryption Required!",
                });
                error = true;
            }

            if (error) {
                return false;
            }
            fd.append("smtp_enabled", true);
            fd.append("smtp_server", fromData.smtp_server);
            fd.append("smtp_port", fromData.smtp_port);
            fd.append("smtp_username", fromData.smtp_username);
            fd.append("smtp_password", fromData.smtp_password);
            fd.append("smtp_encryption", fromData.smtp_encryption);
        }
        if (this.state.selectedFile) {
            fd.append("fileToUpload", this.state.selectedFile);
        }

        fd.append("beta_features", this.state.beta_features);
        fd.append("enable_agent_training", this.state.enable_agent_training);
        fd.append("show_create", this.state.show_create);
        fd.append("pricing_restricted", this.state.pricing_restricted);
        if (this.state.isEdit) {
            const organization_id = this.props.selectedOrganization.id;

            UpdateOrganization(organization_id, fd)
                .then((response) => {
                    this.setState({ show_spinner: false });
                    if (response.success) {
                        this.props.updateOrganizations();
                    } else {
                        this.setState({
                            smtpErrorMessage: response.message,
                            httpErrorMessage: response.message,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({ show_spinner: false });
                });
        } else {
            CreateOrganization(fd)
                .then((response) => {
                    this.setState({ show_spinner: false });
                    if (response.success) {
                        // update organization ui with new data
                        this.props.updateOrganizations();
                    } else {
                        this.setState({
                            smtpErrorMessage: response.message,
                            httpErrorMessage: response.message,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({ show_spinner: false });
                });
        }
    };

    updateChange(event) {
        const targetName = event.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        if (targetName === "ach_info_for_billing") {
            formData[targetName] = event.target.checked;
        } else {
            formData[targetName] = event.target.value.trim();
        }

        this.setState({ formData: formData, errorMessage: "" });
    }

    onFileChange = (event) => {
        if (event.target.files[0]) {
            this.setState({
                selectedFile: event.target.files[0],
                src: URL.createObjectURL(event.target.files[0]),
                alt: event.target.files[0].name,
            });
        }
    };
    addDefaultSrc(ev) {
        ev.target.src = "/images/avtar.svg";
        this.setState({ classDefault: true });
    }
    render() {
        const {
            src,
            errorMessage,
            show_spinner,
            smtpErrorMessage,
            smtp_ports,
            smtp_encryptions,
            smtpSuccessMessage,
            showUpdateUwUpdate,
            classDefault,
            is_submitted,
            formData,
            errors,
            relationShipManagers,
            isEdit,
            mainAdminManagers,
            emsOffices,
            allowedProcessorsOptions
        } = this.state;
        const orgTypeOptions = [
            { label: "Agent", value: "hands_on" },
            { label: "Referral Partner", value: "hands_off" },
        ];
        return (
            <ReactModal isOpen={this.props.show} className="add-org-modal">
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit organization" : "Add organization"}
                    </h4>
                </div>
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <div className="logoupload">
                        <div
                            className={
                                src && !classDefault
                                    ? "image-load"
                                    : "uploadedlogo"
                            }
                        >
                            <img
                                onError={(evt) => this.addDefaultSrc(evt)}
                                src={src ? src : "/images/avtar.svg"}
                                alt={"avatar"}
                            />
                        </div>
                        <div className="adduploadedlogo">
                            <label className="filelabel">
                                <span className="title">
                                    + Add logo <br></br>
                                    <p className="subtitle">Optional</p>
                                </span>
                                <input
                                    className="FileUpload1"
                                    id="FileInput"
                                    type="file"
                                    onChange={this.onFileChange}
                                />
                            </label>
                        </div>
                    </div>
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleAddOrganization(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="add-organization-form"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Organization name"
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.name && !!errors.name
                                            }
                                            isValid={
                                                is_submitted && !errors.name
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            ISO / Agent DBA
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={6}
                                        lg={6}
                                        className="px-3 modal-pd"
                                    >
                                        <Form.Control
                                            placeholder="Company Name"
                                            type="text"
                                            name="company_name"
                                            value={values.company_name}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.company_name &&
                                                !!errors.company_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.company_name
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            Company Name
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.company_name}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={6}
                                        lg={6}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Main Contact"
                                            type="text"
                                            name="main_contact"
                                            value={values.main_contact}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.main_contact &&
                                                !!errors.main_contact
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.main_contact
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            Main Contact
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.main_contact}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        className="px-3 modal-pd"
                                        as={Col}
                                        xs={12}
                                        lg={6}
                                        controlId="whitelabel_slug"
                                    >
                                        <Form.Control
                                            placeholder="PCI Slug"
                                            type="text"
                                            name="whitelabel_slug"
                                            value={values.whitelabel_slug}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.name &&
                                                !!errors.whitelabel_slug
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.whitelabel_slug
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            PCI Slug
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.whitelabel_slug}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={6}
                                        lg={6}
                                        className="px-3 org-type"
                                    >
                                        <SelectDropDown
                                            options={orgTypeOptions}
                                            name="type"
                                            placeholder="Type"
                                            value={values.type}
                                            handleChange={(selected) => {
                                                let formValue = formData;
                                                formValue["type"] =
                                                    selected.value;
                                                this.setState({
                                                    formData: formValue,
                                                });
                                                errors.type = "";
                                            }}
                                            touched={touched.type}
                                            errors={errors.type}
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Type
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.type}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Cleave
                                            options={{
                                                blocks: [3, 3, 4],
                                                delimiter: "-",
                                                numericOnly: true,
                                            }}
                                            placeholder="Bussiness phone"
                                            name="phone"
                                            value={values.phone}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.phone_direct &&
                                                "is-valid"
                                            } ${touched.phone && !!errors.phone && "is-invalid"}`}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.phone}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Business address"
                                            type="text"
                                            name="address"
                                            value={values.address}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.name && !!errors.address
                                            }
                                            isValid={
                                                is_submitted && !errors.address
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.address}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Business email"
                                            type="text"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.name && !!errors.email
                                            }
                                            isValid={
                                                is_submitted && !errors.email
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {isEdit && (
                                        <Form.Group
                                            className="px-3 modal-pd"
                                            as={Col}
                                            xs={12}
                                            lg={12}
                                            controlId="main_admin"
                                        >
                                            {mainAdminManagers && (
                                                <SelectDropDown
                                                    isSearchable={true}
                                                    options={mainAdminManagers}
                                                    name="main_admin"
                                                    placeholder="Main admin / Residuals Receiver"
                                                    value={values.main_admin}
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        let formValue =
                                                            formData;
                                                        formValue[
                                                            "main_admin"
                                                        ] = selected.value;
                                                        this.setState({
                                                            formData: formValue,
                                                            errorMessage: "",
                                                        });
                                                    }}
                                                    touched={touched.main_admin}
                                                    errors={errors.main_admin}
                                                    is_submitted={is_submitted}
                                                />
                                            )}
                                            <label className="modal-lab">
                                                Main admin / Residuals Receiver
                                            </label>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.main_admin ||
                                                    errorMessage}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    )}
                                    <Form.Group
                                        className="px-3 modal-pd"
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        controlId="primary_contact_id"
                                    >
                                        {relationShipManagers &&
                                            relationShipManagers.length > 0 && (
                                                <SelectDropDown
                                                    isSearchable={true}
                                                    options={
                                                        relationShipManagers
                                                    }
                                                    name="primary_contact_id"
                                                    placeholder="Team Lead"
                                                    value={
                                                        values.primary_contact_id
                                                    }
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        let formValue =
                                                            formData;
                                                        formValue[
                                                            "primary_contact_id"
                                                        ] = selected.value;
                                                        this.setState({
                                                            formData: formValue,
                                                        });
                                                        errors.primary_contact_id =
                                                            "";
                                                    }}
                                                    touched={
                                                        touched.primary_contact_id
                                                    }
                                                    errors={
                                                        errors.primary_contact_id
                                                    }
                                                    is_submitted={is_submitted}
                                                />
                                            )}
                                        <label className="modal-lab">
                                            Team Lead
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.primary_contact_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        className="px-3 modal-pd"
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        controlId="contract_negotiation"
                                    >
                                        {relationShipManagers &&
                                            relationShipManagers.length > 0 && (
                                                <SelectDropDown
                                                    isSearchable={true}
                                                    options={
                                                        relationShipManagers
                                                    }
                                                    name="contract_negotiation"
                                                    placeholder="Lead Owner"
                                                    value={
                                                        values.contract_negotiation
                                                    }
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        let formValue =
                                                            formData;
                                                        formValue[
                                                            "contract_negotiation"
                                                        ] = selected.value;
                                                        this.setState({
                                                            formData: formValue,
                                                        });
                                                        errors.contract_negotiation =
                                                            "";
                                                    }}
                                                    touched={
                                                        touched.contract_negotiation
                                                    }
                                                    errors={
                                                        errors.contract_negotiation
                                                    }
                                                    is_submitted={is_submitted}
                                                />
                                            )}
                                        <label className="modal-lab">
                                            Lead Owner
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.contract_negotiation}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        className="px-3 modal-pd"
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        controlId="uw_id"
                                    >
                                        {relationShipManagers &&
                                            relationShipManagers.length > 0 && (
                                                <SelectDropDown
                                                    isSearchable={true}
                                                    clearValue={
                                                        values?.uw_id
                                                            ? true
                                                            : false
                                                    }
                                                    options={
                                                        relationShipManagers
                                                    }
                                                    name="uw_id"
                                                    placeholder="UW"
                                                    value={values.uw_id}
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        let formValue =
                                                            formData;
                                                        formValue["uw_id"] =
                                                            selected == null
                                                                ? null
                                                                : selected.value;
                                                        this.setState({
                                                            showUpdateUwUpdate:
                                                                this.props
                                                                    ?.selectedOrganization
                                                                    ?.uw_id !=
                                                                selected?.value
                                                                    ? true
                                                                    : false,
                                                            formData: formValue,
                                                        });
                                                        errors.uw_id = "";
                                                    }}
                                                    touched={touched.uw_id}
                                                    errors={errors.uw_id}
                                                    is_submitted={is_submitted}
                                                />
                                            )}
                                        <label className="modal-lab">UW</label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.uw_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {isEdit &&
                                        this.state.showUpdateUwUpdate && (
                                            <Form.Group
                                                className="px-3 modal-pd"
                                                as={Col}
                                                xs={12}
                                                lg={12}
                                            >
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        onChange={(event) => {
                                                            let formValue =
                                                                formData;
                                                            formValue[
                                                                "update_existing_lead_uw_id"
                                                            ] = event.target
                                                                .checked
                                                                ? true
                                                                : false;
                                                            this.setState({
                                                                formData:
                                                                    formValue,
                                                            });
                                                            errors.uw_id = "";
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="web-checkout"
                                                        className="form-check-label"
                                                    >
                                                        <span className="preapp-checkbox" />
                                                        Do you want to update
                                                        existing leads UW?
                                                    </label>
                                                </div>
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {
                                                        errors.update_existing_lead_uw_id
                                                    }
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        )}

                                    <Form.Group
                                        className="px-3 modal-pd"
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        controlId="contact_preference"
                                    >
                                        <SelectDropDown
                                            options={[
                                                {
                                                    label: "Okay to Contact",
                                                    value: 0,
                                                },
                                                {
                                                    label: "Do Not Contact",
                                                    value: 1,
                                                },
                                            ]}
                                            name="contact_preference"
                                            placeholder="Contact Preference"
                                            value={values.contact_preference}
                                            handleChange={(selected) => {
                                                let formValue = formData;
                                                formValue[
                                                    "contact_preference"
                                                ] = selected.value;
                                                this.setState({
                                                    formData: formValue,
                                                });
                                                errors.contact_preference = "";
                                            }}
                                            touched={touched.contact_preference}
                                            errors={errors.contact_preference}
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Contact Preference
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.contact_preference}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <div className="mod-head">
                                        <h4>Revenue share</h4>
                                    </div>
                                    <Form.Group
                                        as={Col}
                                        xs={6}
                                        lg={6}
                                        className="px-3 modal-pd"
                                    >
                                        <Cleave
                                            options={{
                                                numericOnly: true,
                                                blocks: [10],
                                            }}
                                            placeholder="High risk"
                                            name="high_risk"
                                            value={values.high_risk}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.high_risk &&
                                                "is-valid"
                                            } ${touched.high_risk && !!errors.high_risk && "is-invalid"}`}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.high_risk}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={6}
                                        lg={6}
                                        className="px-3"
                                    >
                                        <Cleave
                                            options={{
                                                numericOnly: true,
                                                blocks: [10],
                                            }}
                                            placeholder="Low risk"
                                            name="low_risk"
                                            value={values.low_risk}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.low_risk &&
                                                "is-valid"
                                            } ${touched.low_risk && !!errors.low_risk && "is-invalid"}`}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.low_risk}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd rev-tier"
                                    >
                                        <Cleave
                                            options={{
                                                numericOnly: true,
                                                blocks: [10],
                                            }}
                                            placeholder="Rev share tiers"
                                            name="rev_share_tiers"
                                            value={values.rev_share_tiers}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.rev_share_tiers &&
                                                "is-valid"
                                            } ${touched.rev_share_tiers && !!errors.rev_share_tiers && "is-invalid"}`}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.rev_share_tiers}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd"
                                    >
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="checkbox"
                                                id="web-checkout"
                                                className="form-check-input"
                                                name="ach_info_for_billing"
                                                value={
                                                    values.ach_info_for_billing
                                                }
                                                onChange={handleChange}
                                            />
                                            <label
                                                htmlFor="web-checkout"
                                                className="form-check-label"
                                            >
                                                <span className="preapp-checkbox" />
                                                ACH info for billing
                                            </label>
                                        </div>
                                    </Form.Group>
                                    <div className="mod-head">
                                        <h4>Bank details</h4>
                                    </div>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd"
                                    >
                                        <Form.Control
                                            placeholder="Bank name"
                                            type="text"
                                            name="bank_name"
                                            value={values.bank_name}
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.name &&
                                                !!errors.bank_name
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.bank_name
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.bank_name}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd"
                                    >
                                        <Cleave
                                            options={{
                                                numericOnly: true,
                                                blocks: [10],
                                            }}
                                            placeholder="Routing number"
                                            name="routing_number"
                                            value={values.routing_number}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.routing_number &&
                                                "is-valid"
                                            } ${touched.routing_number && !!errors.routing_number && "is-invalid"}`}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.routing_number}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd"
                                    >
                                        <Cleave
                                            options={{
                                                numericOnly: true,
                                                blocks: [10],
                                            }}
                                            placeholder="Account number"
                                            name="account_number"
                                            value={values.account_number}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.account_number &&
                                                "is-valid"
                                            } ${touched.account_number && !!errors.account_number && "is-invalid"}`}
                                        />
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.account_number}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {this.props.isPcAdmin === true && (
                                        <div>
                                            <div className="mod-head">
                                                <h4>Allowed Processors </h4>
                                            </div>
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                lg={12}
                                                className="px-3 modal-pd"
                                            >
                                                <Select
                                                    isMulti
                                                    name="allowed_processors"
                                                    placeholder="Allowed Processors"
                                                    options={allowedProcessorsOptions}
                                                    value={values?.allowed_processors}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    onChange={(selected) => {

                                                        let formValue = formData;
                                                        formValue["allowed_processors"] = selected;
                                                        this.setState({
                                                            formData: formValue,
                                                            errorMessage: "",
                                                        });
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                    )}
                                    {this.props.isPcAdmin === true && (
                                        <div>
                                            <div className="mod-head">
                                                <h4>EMS Office ( HR / LR ) </h4>
                                            </div>
                                            <Form.Group
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                className="px-3 modal-pd"
                                            >
                                                <SelectDropDown
                                                    options={emsOffices}
                                                    name="ems_office_hr"
                                                    placeholder="HR Office"
                                                    value={values?.ems_office_hr?.toString()}
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        let formValue =
                                                            formData;
                                                        formValue[
                                                            "ems_office_hr"
                                                        ] = selected.value;
                                                        this.setState({
                                                            formData: formValue,
                                                            errorMessage: "",
                                                        });
                                                    }}
                                                />
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                className="px-3"
                                            >
                                                <SelectDropDown
                                                    options={emsOffices}
                                                    name="ems_office_lr"
                                                    placeholder="LR Office"
                                                    value={values?.ems_office_lr?.toString()}
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        let formValue =
                                                            formData;
                                                        formValue[
                                                            "ems_office_lr"
                                                        ] = selected.value;
                                                        this.setState({
                                                            formData: formValue,
                                                            errorMessage: "",
                                                        });
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                    )}

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd"
                                    >
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="checkbox"
                                                id="smtp-enabled"
                                                className="form-check-input"
                                                name="smtp_enabled"
                                                defaultChecked={
                                                    this.state.isSmtpEnabled
                                                }
                                                value={this.state.isSmtpEnabled}
                                                onChange={(handleChange) => {
                                                    this.setState({
                                                        isSmtpEnabled:
                                                            !this.state
                                                                .isSmtpEnabled,
                                                        smtpSuccessMessage: "",
                                                        smtpErrorMessage: "",
                                                    });
                                                }}
                                            />
                                            <label
                                                htmlFor="web-checkout"
                                                className="form-check-label"
                                            >
                                                <span className="preapp-checkbox" />
                                                SMTP Enable
                                            </label>
                                        </div>
                                    </Form.Group>

                                    {this.state.isSmtpEnabled ? (
                                        <div className="mod-head smtp-details">
                                            <h4>SMTP Details</h4>

                                            <Form.Group
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                className="px-3 modal-pd"
                                            >
                                                <Form.Control
                                                    placeholder="SMTP Username"
                                                    type="text"
                                                    name="smtp_username"
                                                    value={
                                                        values.smtp_username
                                                            ? values.smtp_username
                                                            : ""
                                                    }
                                                    onChange={handleChange}
                                                    onKeyPress={(e) =>
                                                        this.handleOnChange(e)
                                                    }
                                                    isInvalid={
                                                        touched.smtp_username &&
                                                        !!errors.smtp_username
                                                    }
                                                    isValid={
                                                        is_submitted &&
                                                        !errors.smtp_username
                                                    }
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {
                                                        this.state
                                                            .smtpUsernameRequired
                                                    }
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                className="px-3 modal-pd"
                                            >
                                                <Form.Control
                                                    placeholder="SMTP Password"
                                                    type="password"
                                                    name="smtp_password"
                                                    value={
                                                        values.smtp_password
                                                            ? values.smtp_password
                                                            : ""
                                                    }
                                                    onChange={handleChange}
                                                    onKeyPress={(e) =>
                                                        this.handleOnChange(e)
                                                    }
                                                    isInvalid={
                                                        touched.smtp_password &&
                                                        !!errors.smtp_password
                                                    }
                                                    isValid={
                                                        is_submitted &&
                                                        !errors.smtp_password
                                                    }
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {
                                                        this.state
                                                            .smtpPasswordRequired
                                                    }
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group
                                                className="px-3 modal-pd"
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                controlId="smtp_port"
                                            >
                                                {smtp_ports && (
                                                    <SelectDropDown
                                                        options={smtp_ports}
                                                        name="smtp_port"
                                                        placeholder="Port"
                                                        value={values.smtp_port}
                                                        handleChange={(
                                                            selected,
                                                        ) => {
                                                            let formValue =
                                                                formData;
                                                            formValue[
                                                                "smtp_port"
                                                            ] = selected.value;
                                                            this.setState({
                                                                formData:
                                                                    formValue,
                                                                errorMessage:
                                                                    "",
                                                                smtpSuccessMessage:
                                                                    "",
                                                                smtpErrorMessage:
                                                                    "",
                                                                errors: {
                                                                    smtpPortRequired:
                                                                        "",
                                                                },
                                                            });
                                                        }}
                                                        errors={
                                                            this.state
                                                                .smtpPortRequired
                                                        }
                                                    />
                                                )}
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {
                                                        this.state
                                                            .smtpPortRequired
                                                    }
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                className="px-3 modal-pd"
                                            >
                                                {smtp_encryptions && (
                                                    <SelectDropDown
                                                        options={
                                                            smtp_encryptions
                                                        }
                                                        name="smtp_encryption"
                                                        placeholder="Encryption"
                                                        value={
                                                            values.smtp_encryption
                                                        }
                                                        handleChange={(
                                                            selected,
                                                        ) => {
                                                            let formValue =
                                                                formData;
                                                            formValue[
                                                                "smtp_encryption"
                                                            ] = selected.value;
                                                            this.setState({
                                                                formData:
                                                                    formValue,
                                                                errorMessage:
                                                                    "",
                                                                smtpSuccessMessage:
                                                                    "",
                                                                smtpErrorMessage:
                                                                    "",
                                                                errors: {
                                                                    smtpPortRequired:
                                                                        "",
                                                                },
                                                            });
                                                        }}
                                                        errors={
                                                            this.state
                                                                .smtpEncryptionRequired
                                                        }
                                                    />
                                                )}
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {
                                                        this.state
                                                            .smtpEncryptionRequired
                                                    }
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                xs={6}
                                                lg={6}
                                                className="px-3 modal-pd"
                                            >
                                                <Form.Control
                                                    placeholder="SMTP Server"
                                                    type="text"
                                                    name="smtp_server"
                                                    value={
                                                        values.smtp_server
                                                            ? values.smtp_server
                                                            : ""
                                                    }
                                                    onChange={handleChange}
                                                    onKeyPress={(e) =>
                                                        this.handleOnChange(e)
                                                    }
                                                    isInvalid={
                                                        touched.smtp_server &&
                                                        !!errors.smtp_server
                                                    }
                                                    isValid={
                                                        is_submitted &&
                                                        !errors.smtp_server
                                                    }
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {
                                                        this.state
                                                            .smtpServerRequired
                                                    }
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                lg={12}
                                                className="px-3 modal-pd"
                                            >
                                                {smtpSuccessMessage ? (
                                                    <Form.Control.Feedback
                                                        type="success"
                                                        className="text-capitalize"
                                                    >
                                                        {smtpSuccessMessage}
                                                    </Form.Control.Feedback>
                                                ) : (
                                                    ""
                                                )}
                                                {smtpErrorMessage ? (
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {smtpErrorMessage}
                                                    </Form.Control.Feedback>
                                                ) : (
                                                    ""
                                                )}
                                            </Form.Group>
                                        </div>
                                    ) : null}

                                    {this.props.isPcAdmin === true && (
                                        <Form.Group
                                            as={Col}
                                            xs={12}
                                            lg={12}
                                            className="px-3 modal-pd"
                                        >
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="checkbox"
                                                    id="beta-feature"
                                                    className="form-check-input"
                                                    name="beta_features"
                                                    defaultChecked={
                                                        this.state.beta_features
                                                    }
                                                    value={
                                                        this.state.beta_features
                                                    }
                                                    onChange={(
                                                        handleChange,
                                                    ) => {
                                                        this.setState({
                                                            beta_features:
                                                                !this.state
                                                                    .beta_features,
                                                        });
                                                    }}
                                                />
                                                <label
                                                    htmlFor="beta_features"
                                                    className="form-check-label"
                                                >
                                                    <span className="preapp-checkbox" />
                                                    Beta Feature.
                                                </label>
                                            </div>
                                        </Form.Group>
                                    )}

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd"
                                    >
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="checkbox"
                                                id="beta-feature"
                                                className="form-check-input"
                                                name="enable_agent_training"
                                                defaultChecked={
                                                    this.state
                                                        .enable_agent_training
                                                }
                                                value={
                                                    this.state
                                                        .enable_agent_training
                                                }
                                                onChange={(handleChange) => {
                                                    this.setState({
                                                        enable_agent_training:
                                                            !this.state
                                                                .enable_agent_training,
                                                    });
                                                }}
                                            />
                                            <label
                                                htmlFor="enable_agent_training"
                                                className="form-check-label"
                                            >
                                                <span className="preapp-checkbox" />
                                                Enable Agent Training
                                            </label>
                                        </div>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd"
                                    >
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="checkbox"
                                                id="beta-feature"
                                                className="form-check-input"
                                                name="show_create"
                                                defaultChecked={
                                                    this.state.show_create
                                                }
                                                value={this.state.show_create}
                                                onChange={(handleChange) => {
                                                    this.setState({
                                                        show_create:
                                                            !this.state
                                                                .show_create,
                                                    });
                                                }}
                                            />
                                            <label
                                                htmlFor="show_create"
                                                className="form-check-label"
                                            >
                                                <span className="preapp-checkbox" />
                                                Allow Application Creation
                                            </label>
                                        </div>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        lg={12}
                                        className="px-3 modal-pd"
                                    >
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="checkbox"
                                                id="beta-feature"
                                                className="form-check-input"
                                                name="pricing_restricted"
                                                defaultChecked={
                                                    this.state.pricing_restricted
                                                }
                                                value={this.state.pricing_restricted}
                                                onChange={(handleChange) => {
                                                    this.setState({
                                                        pricing_restricted:
                                                            !this.state
                                                                .pricing_restricted,
                                                    });
                                                }}
                                            />
                                            <label
                                                htmlFor="pricing_restricted"
                                                className="form-check-label"
                                            >
                                                <span className="preapp-checkbox" />
                                                Pricing Restricted? 
                                            </label>
                                        </div>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="error-message">{errorMessage}</p>
                {!this.state.isSmtpEnabled && this.state.httpErrorMessage ? (
                    <>
                        <span className="text-danger">
                            * {this.state.httpErrorMessage}
                        </span>
                        <br />
                    </>
                ) : null}
                <div className="modal-footer">
                    <button
                        form="add-organization-form"
                        type="submit"
                        className="btn confirm-button"
                    >
                        {isEdit ? "Update" : "Add"}
                    </button>
                    <button
                        className="btn cancel-button"
                        onClick={() => this.props.handleClose()}
                    >
                        Cancel
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default AddOrganizationModal;
